import Api from "../../../../service";
import {
  RESET_COMPETITIONCLUBS,
  SET_COMPETITIONCLUBS,
  SET_ERROR,
} from "./constants";

const setCompetitionClubs = (data) => ({
  type: SET_COMPETITIONCLUBS,
  data,
});

const setError = (data) => ({
  type: SET_ERROR,
  data,
});

export const getCompetitionClubs = (data) => (dispatch) =>
  Api.competition
    .getClubs(data)
    .then((response) => {
      dispatch(setCompetitionClubs(response));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error));
    });

export const resetCompetitionClubs = (data) => ({
  type: RESET_COMPETITIONCLUBS,
  data,
});
